import React from "react"
import styled from "styled-components"

export default function RoleSummary({ summary, analysis }) {
  return (
    <Wrapper className="RoleSummary">
      <TitleWrapper>簡介</TitleWrapper>
      <ContentWrapper>
        <p>{summary}</p>
        <h3>分析結果</h3>
        <p>{analysis?.first}</p>
        <p className="bold">{analysis?.second}</p>
      </ContentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 24px;
  position: relative;
  border: 1px solid #00fff0;
  border-radius: 0 12px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  background: linear-gradient(
    135deg,
    rgba(0, 255, 238, 0.264),
    rgba(0, 255, 238, 0)
  );
  backdrop-filter: blur(2px);
  z-index: 3;
  @media (max-width: 1200px) {
    z-index: 1;
    border-radius: 12px;
  }
`
const TitleWrapper = styled.h1`
  position: absolute;
  left: -80px;
  top: -1px;
  margin: 0;
  width: 80px;
  font-size: 32px;
  color: #000;
  font-weight: 700;
  background-color: #00fff0;
  padding: 30px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: vertical-lr;
  clip-path: polygon(0px 0, 100% 0%, 100% 100%, 30px 100%, 0 calc(100% - 30px));
  @media (max-width: 1200px) {
    all: unset;
    margin: 0;
    font-size: 32px;
    color: #00fff0;
    font-weight: 700;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 49vh;
  overflow: auto;
  @media (max-width: 1200px) {
    max-height: 100%;
    overflow: auto;
  }
  h3 {
    margin: 0;
    font-size: 24px;
    color: #00fff0;
    border-top: 1px solid #00fff0;
    padding-top: 20px;
  }
  p {
    margin: 0;
    font-size: 16px;
    color: #00fff0;
    &.bold {
      font-weight: 700;
      font-size: 16px;
    }
  }
`
